
<button mat-icon-button (click)="btnClickedHandler()">
  @if (valueBtn) {
    <mat-icon>check</mat-icon>
  } @else {
    <mat-icon>close</mat-icon>
  }
</button>